export const defaultValuesForm = (currentProduct: Partial<any> | undefined) => ({
  tips: currentProduct?.tips || 0,
});
